import type { ActionModel } from '@jet/environment/types/models';

type ModifyPlaylistActionType = 'addToPlaylist' | 'create' | 'editPlaylist';

export interface ModifyPlaylistAction extends ActionModel {
    $kind: 'modifyPlaylistAction';
    url?: string;
    type: ModifyPlaylistActionType;
    name?: string;
    description?: string;
    playlistId?: string;
    songs?: string[];
    librarySongs?: any[];
    offset?: number;
}

export function makeModifyPlaylistAction(
    type: ModifyPlaylistActionType,
    attributes: Pick<
        ModifyPlaylistAction,
        | 'name'
        | 'songs'
        | 'playlistId'
        | 'url'
        | 'description'
        | 'librarySongs'
        | 'offset'
    >,
): ModifyPlaylistAction {
    return {
        $kind: 'modifyPlaylistAction',
        type,
        ...attributes,
        actionMetrics: {
            data: [],
            custom: {},
        },
    };
}
